module.exports = __webpack_public_path__ + "images/emoji/ear_of_rice.ebe75522487c5ff2412c.png";